import { render, staticRenderFns } from "./remains-list.vue?vue&type=template&id=26b70b45&"
import script from "./remains-list.vue?vue&type=script&lang=js&"
export * from "./remains-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports